'use client';
import _logger from '@lib/logger';
import {Configuration} from '@linx-security/api-specs';
import {
  getCastErrorMiddleware,
  getIpNotAllowedMiddleware,
  getLogMiddleware,
  getSessionMiddleware,
  queryParamsStringify,
} from '@linx-security/api';
import {signOut} from 'next-auth/react';

import {redirectToIpNotAllowed} from '../../_lib/access-denied-redirect';
import {routes} from '../../_lib/browser/api-routes';

import {ConsoleApi} from './ConsoleApi';

const logger = _logger.child?.({module: `api-client-browser`}, {});

const defaultConfig = new Configuration({
  basePath: routes.baseURL,
  queryParamsStringify,
  middleware: [
    getLogMiddleware(logger),
    getSessionMiddleware(logger, () => signOut()),
    getIpNotAllowedMiddleware(logger, redirectToIpNotAllowed),
    getCastErrorMiddleware(logger),
  ],
});

export const getClient = (config: Configuration = defaultConfig) => {
  const client = new ConsoleApi(config);
  return client;
};
